import React, { ReactNode } from 'react'
import { ColumnWrapper } from './style'

const Column = ({
  children,
  gap,
  stylecolumn,
}: {
  children: ReactNode
  gap?: number
  stylecolumn?: string
}) => {
  return (
    <ColumnWrapper gap={gap} stylecolumn={stylecolumn}>
      {children}
    </ColumnWrapper>
  )
}

export default Column
